import type { Sound } from '@ssml-editor/editor-vue';

export default <Sound[]>[
  {
    name: '狗-狂吠',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/sound/animal/public/%E7%8B%97-%E7%8B%82%E5%90%A0.wav',
  },
  {
    name: '狗-咆哮',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/sound/animal/public/%E7%8B%97-%E5%92%86%E5%93%AE.wav',
  },
  {
    name: '鸡-打鸣',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/sound/animal/public/%E9%B8%A1-%E6%89%93%E9%B8%A3.wav',
  },
  {
    name: '狼-嚎叫',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/sound/animal/public/%E7%8B%BC-%E5%9A%8E%E5%8F%AB.wav',
  },
  {
    name: '驴-喷嚏',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/sound/animal/public/%E9%A9%B4-%E5%96%B7%E5%9A%8F.wav',
  },
  {
    name: '马-嘶鸣',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/sound/animal/public/%E9%A9%AC-%E5%98%B6%E9%B8%A3.wav',
  },
  {
    name: '猫-叫',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/sound/animal/public/%E7%8C%AB-%E5%8F%AB.wav',
  },
  {
    name: '牛-哞',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/sound/animal/public/%E7%89%9B-%E5%93%9E.wav',
  },
  {
    name: '牛-呻吟',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/sound/animal/public/%E7%89%9B-%E5%91%BB%E5%90%9F.wav',
  },
  {
    name: '乌鸦-嘎叫',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/sound/animal/public/%E4%B9%8C%E9%B8%A6-%E5%98%8E%E5%8F%AB.wav',
  },
  {
    name: '乌鸦-叫',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/sound/animal/public/%E4%B9%8C%E9%B8%A6-%E5%8F%AB.wav',
  },
];
